import { PapiGroup, PapiUser } from '@wix/da-papi-types';

export const groups: PapiUser[] = [
  {
    userId: 399795,
    useridUuid: '756131e6-4105-4cfb-90d3-a9aca66eb6f2',
    username: 'hq',
    usericon: 'https://a.deviantart.net/avatars/h/q/hq.png?5',
    type: 'super group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 11783475,
    useridUuid: '115302c4-527c-405e-97b1-887e6fead8f0',
    username: 'printscommunity-long',
    usericon: 'https://a.deviantart.net/avatars/p/r/printscommunity.png?2',
    type: 'super group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 11144543,
    useridUuid: 'e9ad7e4b-914b-4a5b-a852-99695966d34c',
    username: 'devBUG',
    usericon: 'https://a.deviantart.net/avatars/d/e/devbug.gif?7',
    type: 'super group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 188081,
    useridUuid: '6c2295d7-5cca-4eb3-8630-19bdda967396',
    username: 'dt',
    usericon: 'https://a.deviantart.net/avatars/d/t/dt.png?3',
    type: 'group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 44881041,
    useridUuid: 'ed2d85dd-7728-45e5-bffc-003b156284fb',
    username: 'Brawlers-with-art',
    usericon: 'https://a.deviantart.net/avatars/b/r/brawlers-with-art.jpg?1',
    type: 'group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 21274428,
    useridUuid: '0ec9dc7f-1bb7-4cbf-98f3-76b2b5540fd4',
    username: 'DA-LOVERS',
    usericon: 'https://a.deviantart.net/avatars/d/a/da-lovers.png?4',
    type: 'super group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 23913912,
    useridUuid: '37c368c2-41e4-45c9-a0cd-6bb70643a790',
    username: 'Fantasy-NPC',
    usericon: 'https://a.deviantart.net/avatars/f/a/fantasy-npc.jpg?4',
    type: 'super group',
    isNewDeviant: true,
    isGroup: true,
  },
  {
    userId: 35542637,
    useridUuid: 'bcd8fb6e-c2f3-4007-b1c8-60bf7e442bb5',
    username: 'TheChurchOfEpic',
    usericon: 'https://a.deviantart.net/avatars/t/h/thechurchofepic.png?6',
    type: 'group',
    isNewDeviant: true,
    isGroup: true,
  },
];

export const groupsWithDetails: PapiGroup[] = [
  {
    user: {
      username: 'FishLovers',
      usericon: 'https://a.deviantart.net/avatars/f/i/fishlovers.gif?6',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-01-17T17:01:01-0800',
      },
      profile: {
        tagline: 'We love fish!',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 1138,
        friends: 0,
      },
      userId: 12735600,
      useridUuid: 'd54a2c80-2dc1-44c3-92da-7d5c5d7ac940',
    },
    description:
      'Love drawing fish? Love photographing fish? Love digitally editing fish? Love eating fish? Love FISH?! Join this group, for fish lovers, by fish lovers.',
  },
  {
    user: {
      username: 'Betta-Fish-Fan-Club',
      usericon:
        'https://a.deviantart.net/avatars/b/e/betta-fish-fan-club.gif?2',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-01-10T18:19:11-0800',
      },
      profile: {
        tagline: 'betta fish pets',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 673,
        friends: 0,
      },
      userId: 12665532,
      useridUuid: '424e770a-1ab7-40c9-ad90-caecea7d0429',
    },
    description:
      "This is a group dedicated to all you betta fish owners on DA! The group will focus on betta fish and their care, photos of member's fish and providing a place to view wonderful betta fish art submitted by the members :)",
  },
  {
    user: {
      username: 'oOoFish-FrenzyoOo',
      usericon: 'https://a.deviantart.net/avatars/o/o/ooofish-frenzyooo.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2012-01-06T20:29:38-0800',
      },
      profile: {
        tagline: 'A home for your fishie friends~',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 15,
        friends: 0,
      },
      userId: 20454371,
      useridUuid: '94bd8be8-d73a-4cf2-be05-2a7f5ec8d2be',
    },
    description:
      'This is mainly a group for people with fish characters :D <sub> <sub> <sub>more will be added later ;v;',
  },
  {
    user: {
      username: 'Fish-lovers',
      usericon: 'https://a.deviantart.net/avatars/f/i/fish-lovers.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2008-04-02T22:44:21-0700',
      },
      profile: {
        tagline: '~Fish keepers and admirers~',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 539,
        friends: 0,
      },
      userId: 7021702,
      useridUuid: '0e1a872b-e24a-4810-86c7-ef72b4745669',
    },
    description:
      "A group for everyone who loves and/or keeps fish to submit their work, get to know each other, and to highlight the fantastic fish art found here on DeviantART.\n\nIn the process, the gallery will end up becoming something like a fish visual encyclopedia.\n\nYou can submit fish art, photos, advice, or information.\nAll submissions must be relating to fish as pets or wild animals, not as food or farming. \n\nThere is a heavy bias on Freshwater fish in this club. This is not because we don't want marine here, it's simply due to that fact that the admin only keep freshwater fish. Sorry to any marine fanatics!",
  },
  {
    user: {
      username: 'KoiFish-Forever',
      usericon: 'https://a.deviantart.net/avatars/k/o/koifish-forever.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2018-02-23T16:19:29-0800',
      },
      profile: {
        tagline: 'Koi Fish nest upon us',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 8,
        friends: 0,
      },
      userId: 45058328,
      useridUuid: 'a36c75ad-4f8d-43b0-9e78-b6e02a909a03',
    },
    description:
      'Rules are the same as rules for all groups and the whole of DeviantArt.\nPlease only join if you are a true lover of koi fish.\nThank you!\n\nBTW, please respect all admins and all deviants overall. Thank you!~',
  },
  {
    user: {
      username: 'Betta-Fish-Group',
      usericon: 'https://a.deviantart.net/avatars/b/e/betta-fish-group.jpg?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2013-05-26T21:13:25-0700',
      },
      profile: {
        tagline: 'betta fish, siamese fighting, pe',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 252,
        friends: 0,
      },
      userId: 26859690,
      useridUuid: '5814b46e-afe8-4879-a81e-b198b5411133',
    },
    description:
      "This is a group for Betta Fish or Siamese Fighting Fish\nPlease submit your Photos, Paintings, Drawings, Crafts,Tank Displays and a Betta Memorial in memory of pur Betta's and contests with points for prizes :dance:\nThank you",
  },
  {
    user: {
      username: 'Fish-Infinity',
      usericon: 'https://a.deviantart.net/avatars/f/i/fish-infinity.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-05-25T16:01:23-0700',
      },
      profile: {
        tagline: 'The Place For Fish Fans',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 214,
        friends: 0,
      },
      userId: 13934113,
      useridUuid: '39628559-7d14-4d64-b0d7-16b2c642b401',
    },
    description:
      "Do you love fish? Do you own an aquarium or two? If you're a fan of our scaly little friends, Fish Infinity is the place for you!",
  },
  {
    user: {
      username: 'HaremOfDeadFish',
      usericon: 'https://a.deviantart.net/avatars/h/a/haremofdeadfish.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2012-12-22T17:12:20-0800',
      },
      profile: {
        tagline: 'Dead Fish = ART',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 12,
        friends: 0,
      },
      userId: 24836128,
      useridUuid: 'd8b8e836-1a5f-4ba5-8500-15baae7c50d1',
    },
    description:
      'gARTerART , THEAWESOMEPEOPLEFROMSHILINSLIVESTREAM (aka TAPFSLS), Beautiful Artist Meet Fate, Harem of Feet/Dead Fish and many more names could describe us. We are fab.',
  },
  {
    user: {
      username: 'Banana-Fish-Group',
      usericon: 'https://a.deviantart.net/avatars/b/a/banana-fish-group.jpg?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2018-07-28T14:24:35-0700',
      },
      profile: {
        tagline: 'a perfect day for banana fish',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 9,
        friends: 0,
      },
      userId: 46299608,
      useridUuid: '286d4357-7389-4f85-907e-b9225a9cee9d',
    },
    description:
      'this is a group for fans of Banana Fish! \nany art, cosplay, etc. is welcome, hope you enjoy!! \n\nMOD APPS OPEN PLEASE DM ME :iconsplatoon-2: \n\nMods: \n:iconsplatoon-2:',
  },
  {
    user: {
      username: 'Clown-Fish-Love',
      usericon: 'https://a.deviantart.net/avatars/c/l/clown-fish-love.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2012-07-29T05:21:22-0700',
      },
      profile: {
        tagline: 'Clown Fish Fans!!!',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 24,
        friends: 0,
      },
      userId: 22918455,
      useridUuid: 'abc330d4-7127-43ab-93ee-3f21fdf4d514',
    },
    description: "We're a group for fans of all the Clown fish out there.",
  },
  {
    user: {
      username: 'Fish-Breedables',
      usericon: 'https://a.deviantart.net/avatars/f/i/fish-breedables.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2016-10-09T13:55:56-0700',
      },
      profile: {
        tagline: '',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 2,
        friends: 0,
      },
      userId: 40658554,
      useridUuid: '6d1c72be-dbff-46b7-a310-72917ec9bcd8',
    },
    description:
      'We like fish, we like art and we like breedables.\nJoin us now if you do to!',
  },
  {
    user: {
      username: 'Koi-Fish-Love',
      usericon: 'https://a.deviantart.net/avatars/k/o/koi-fish-love.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2012-07-29T05:34:11-0700',
      },
      profile: {
        tagline: 'Koi Fish Lovers!!!',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 75,
        friends: 0,
      },
      userId: 22918532,
      useridUuid: '2ef768d7-e827-497f-8180-7df7668d3cfe',
    },
    description: "We're a group for fans of all            Koi Fish.",
  },
  {
    user: {
      username: 'FishHooksOC-Club',
      usericon: 'https://a.deviantart.net/avatars/f/i/fishhooksoc-club.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2011-04-16T21:26:12-0700',
      },
      profile: {
        tagline: 'Better than canon.',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 49,
        friends: 0,
      },
      userId: 17301301,
      useridUuid: 'c1b32ae1-c933-4408-8a55-ae39cc40d20e',
    },
    description:
      'If you have an OC for the show Fish Hooks, or love the designs of other OCs, then this is the group for you BD',
  },
  {
    user: {
      username: 'ChesireFish',
      usericon: 'https://a.deviantart.net/avatars/c/h/chesirefish.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2011-03-07T20:03:44-0800',
      },
      profile: {
        tagline: 'SEXY FISH IS CHESIRE FISH',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 30,
        friends: 0,
      },
      userId: 16833828,
      useridUuid: 'da805aaa-7ed6-4240-977c-617e1092521f',
    },
    description:
      "An RP group about teens who get another chance to 'live' in Wonderland.",
  },
  {
    user: {
      username: 'unaFish',
      usericon: 'https://a.deviantart.net/avatars/u/n/unafish.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-07-04T16:31:52-0700',
      },
      profile: {
        tagline: 'GO FISH!',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 7,
        friends: 0,
      },
      userId: 14299927,
      useridUuid: '643c4adc-3e65-491e-8faf-ce531bf56a96',
    },
    description: '',
  },
  {
    user: {
      username: 'Fish-And-Frying-Pan',
      usericon:
        'https://a.deviantart.net/avatars/f/i/fish-and-frying-pan.jpg?6',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-12-05T11:44:42-0800',
      },
      profile: {
        tagline: 'Hungary x Seychelles',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 52,
        friends: 0,
      },
      userId: 15882574,
      useridUuid: '3445a46a-c0c4-461f-90aa-61d77f99e688',
    },
    description: 'HungaryxSeychelles~!\r\n\r\nThe Fish and Frying Pan couple!',
  },
  {
    user: {
      username: 'FishHookstheMovie',
      usericon: 'https://a.deviantart.net/avatars/f/i/fishhooksthemovie.png?2',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2011-02-05T14:29:30-0800',
      },
      profile: {
        tagline: 'He must decide..College or Love?',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 4,
        friends: 0,
      },
      userId: 16469245,
      useridUuid: '087e3c12-1983-4c28-a01b-91b06b8455ef',
    },
    description:
      'I, rablpn, am trying to make a change to all things Disney. And that is, Fish Hooks: The Movie. The best shows have had a theatarical movie, Spongebob, South Park, The Simpsons, Hannah Montana etc. A movie could really change the show and make it popular. I already know the creator of Fish Hooks himself, Noah Z. Jones. But I need your support to help the pitch! You can draw concept art, write screen parts, or do anything to pull this together! And with your help, I\'ll PUT YOUR NAME IN THE CREDITS IN "supporters"! So go ahead, post a comment saying you\'d like to enter, and help make this dream a reality!',
  },
  {
    user: {
      username: 'AuraSterly-Koi-Fish',
      usericon:
        'https://a.deviantart.net/avatars/a/u/aurasterly-koi-fish.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2018-03-27T09:13:32-0700',
      },
      profile: {
        tagline: "Aura and Cly's Species",
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 4,
        friends: 0,
      },
      userId: 45322788,
      useridUuid: 'a84078ee-8d89-44c6-9cbd-aa0c5181d5e4',
    },
    description:
      "Hello! This is a group for the AuraSterly Koi Fish! this is a closed species, but don't worry, there are ways to get one! Be on the look out for our many subspecies!\nDiscord sever: https://discord.gg/MSAkrQ",
  },
  {
    user: {
      username: 'Fish-OCs',
      usericon: 'https://a.deviantart.net/avatars/f/i/fish-ocs.jpg?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-05-15T23:47:41-0700',
      },
      profile: {
        tagline: '',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 109,
        friends: 0,
      },
      userId: 13843709,
      useridUuid: '5fdac345-79e9-42ea-936a-7bb5c6fe3f8b',
    },
    description: "We're a group dedicated to fish characters!!! <333",
  },
  {
    user: {
      username: 'GingerFish-Fans',
      usericon: 'https://a.deviantart.net/avatars/g/i/gingerfish-fans.png?4',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-12-05T12:33:02-0800',
      },
      profile: {
        tagline: 'Leopard-hoodie groupies',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 27,
        friends: 0,
      },
      userId: 15883043,
      useridUuid: 'c80f129e-5f25-4f5e-abc5-e305c8304bd8',
    },
    description: 'Fanclub for Ginger Fish (drummer of Marilyn Manson)',
  },
  {
    user: {
      username: 'Freddi-Fish-Club',
      usericon: 'https://a.deviantart.net/avatars/f/r/freddi-fish-club.gif?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-01-16T17:21:39-0800',
      },
      profile: {
        tagline: '',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 38,
        friends: 0,
      },
      userId: 12724800,
      useridUuid: '2d2dfd62-df14-43e4-a9ac-820f99c04d4e',
    },
    description:
      "I am Leila Katherine Ganjaei, (a.k.a. Angel-Sweetheart on Deviantart), and I am the founder of the Freddi Fish Club. If you haven't heard of her, here's what she is all about.\r\n\r\nFreddi Fish is a spunky young detective who's always up for a new challenge. Aiding in Freddi's underwater investigation skills are her sharp eye for detail, polite yet brave demeanor, patience and eagerness to help those in need. She loves learning new things at school, reading, and snacking on Grandma Grouper's famous Peanut Butter & Jellyfish sandwiches.\r\n\r\nLuther is Freddi's best friend and sleuthing sidekick. He's sometimes a little goofy and impulsive, and he doesn't always think things through, but Freddi usually manages to convince him to do the right thing. Luther likes school but he’s the class clown. He prefers to spend time trying to swim loop-de-loops, making funny faces and gulping down delectable chocolate covered worm doodles.\r\n\r\nIt was originally created by Humongous Entertainment in the US, and Transposia in Belgium.\r\n\r\nI enjoy you all enjoy this group. Have fun!",
  },
  {
    user: {
      username: 'BlobFish-Fanbase',
      usericon: 'https://a.deviantart.net/avatars/b/l/blobfish-fanbase.jpg?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2016-09-06T17:49:52-0700',
      },
      profile: {
        tagline: 'The SEXIEST creature alive',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 1,
        friends: 0,
      },
      userId: 40379529,
      useridUuid: '6ade2c1a-ca44-4985-842a-c357221e5fa2',
    },
    description:
      'We love blobby masses.\n\nOnly rule- Post are of the sexiest fish in the sea. The Blobfish',
  },
  {
    user: {
      username: 'Mr-Fish-Fan-Club',
      usericon: 'https://a.deviantart.net/avatars/m/r/mr-fish-fan-club.jpg?2',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2012-08-26T12:01:41-0700',
      },
      profile: {
        tagline: 'Icon from: coelasquid',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 3,
        friends: 0,
      },
      userId: 23246821,
      useridUuid: 'd3b2d2fc-b775-40e5-8248-488e6248aa09',
    },
    description:
      'A group for you Mr. Fish fans out there who would like to see him on Deviant art.',
  },
  {
    user: {
      username: 'Angler-Fish-Lovers',
      usericon: 'https://a.deviantart.net/avatars/a/n/angler-fish-lovers.png?1',
      type: 'group',
      isNewDeviant: true,
      isGroup: true,
      details: {
        sex: 'n',
        age: null,
        joindate: '2010-10-10T00:34:24-0700',
      },
      profile: {
        tagline: '',
        website: 'http://',
        userIsArtist: false,
        artistLevel: null,
        artistSpeciality: null,
        realName: '',
      },
      stats: {
        watchers: 19,
        friends: 0,
      },
      userId: 15378425,
      useridUuid: '7f81364d-03f0-4a64-b2ae-8630eba698b2',
    },
    description:
      'A group for fellow Angler fish enthusiasts.... Angler fish are predatory fish that use a lure to attract prey... Here is info on the different types of anglerfish: http://en.wikipedia.org/wiki/Lophiiformes\n\nIf you love frogfish,monkfish/goosefish, deep-sea anglerfish, anything relating to anglerfish, then this is the group for you!',
  },
];

export const moreGroups = [
  ...groups,
  ...groupsWithDetails.map(group => group.user),
];
